import React from 'react';

export default function PageHeader(props) {
    const element = (
    <>
        <table id="tblHeader" style={{width: '100%'}}>
            <tbody> 
                <tr>
                    <td className='titleGradient grayBorderCell'>
                        <span className='pageHeader'><strong>☢ REACT Popcorn ☢</strong></span>
                    </td>
                </tr>
            </tbody>
        </table>
        <img id='imgLoop' className='imageLoading' src='https://cdn.alex-souza.com/media/images/popcorn/infinity.gif' alt='Loading' />
    </>
    );
    return element;
}